import { createAsyncThunk } from "@reduxjs/toolkit";
import * as postApi from "../../api/requests/post";
import * as hashtagApi from "../../api/requests/hashtag";

export const getAllPosts = createAsyncThunk(
  "post/getAllPosts",
  async (page) => {
    try {
      const response = await postApi.getAllPosts(page);
      return response;
    } catch (error) {
      return error;
    }
  },
);

export const getTrendingPosts = createAsyncThunk(
  "post/getTrendingPosts",
  async (page) => {
    try {
      const response = await postApi.getTrendingPosts(page);
      return response;
    } catch (error) {
      return error;
    }
  },
);

export const getAllVideos = createAsyncThunk(
  "post/videos",
  async ({ id, page, oneVideoPerUser, latestSixVideos }) => {
    try {
      const response = await postApi.getAllVideos(
        id,
        page,
        oneVideoPerUser,
        latestSixVideos,
      );
      return response;
    } catch (error) {
      return error;
    }
  },
);

export const getPollPosts = createAsyncThunk(
  "post/getPollPosts",
  async (page) => {
    try {
      const response = await postApi.getPollPosts(page);
      return response;
    } catch (error) {
      return error;
    }
  },
);

export const getRacePosts = createAsyncThunk(
  "post/getRacePosts",
  async (page) => {
    try {
      const response = await postApi.getRacePosts(page);
      return response;
    } catch (error) {
      return error;
    }
  },
);

export const getMarketPosts = createAsyncThunk(
  "post/getMarketPosts",
  async (page) => {
    try {
      const response = await postApi.getMarketPosts(page);
      return response;
    } catch (error) {
      return error;
    }
  },
);

export const getHashtagPosts = createAsyncThunk(
  "post/getHashtagPosts",
  async ({ tag, page }) => {
    try {
      const response = await postApi.getHashtagPosts(tag, page);
      return response;
    } catch (error) {
      return error;
    }
  },
);
export const searchPosts = createAsyncThunk(
  "post/searchPosts",
  async ({ query, page }) => {
    try {
      const response = await postApi.searchPosts(query, page);
      return response;
    } catch (error) {
      return error;
    }
  },
);

export const getTrends = createAsyncThunk("post/getTrends", async () => {
  try {
    const response = await postApi.getTrends();
    return response;
  } catch (error) {
    return error;
  }
});

export const joinHashtag = createAsyncThunk(
  "hashtag/join",
  async (tag, { dispatch }) => {
    try {
      const response = await hashtagApi.joinHashtag(tag);
      return response;
    } catch (error) {
      return error;
    }
  },
);

export const leaveHashtag = createAsyncThunk(
  "hashtag/leave",
  async (tag, { dispatch }) => {
    try {
      const response = await hashtagApi.leaveHashtag(tag);
      return response;
    } catch (error) {
      return error;
    }
  },
);

export const deleteTrend = createAsyncThunk(
  "post/deleteTrend",
  async (tag, { dispatch }) => {
    try {
      const response = await postApi.deleteTrend(tag);
      if (response?.status === 200) {
        // Refresh trends after deletion
        dispatch(getTrends());
      }
      return response;
    } catch (error) {
      return error;
    }
  },
);

export const getFollowingPosts = createAsyncThunk(
  "post/getFollowingPosts",
  async (page) => {
    try {
      const response = await postApi.getFollowingPosts(page);
      return response;
    } catch (error) {
      return error;
    }
  },
);

export const getPostById = createAsyncThunk(
  "post/getPostById",
  async (postId, { rejectWithValue }) => {
    try {
      const response = await postApi.getPostById(postId);
      // Assuming postApi returns the data directly.
      // If it returns an axios response, use response.data
      return response;
    } catch (error) {
      // This passes the backend response (status, message) to the reducer
      return rejectWithValue({
        status: error.response?.status,
        message: error.response?.data?.message || "An error occurred",
      });
    }
  },
);

export const getPostPreview = createAsyncThunk(
  "post/getPostPreview",
  async (postId) => {
    try {
      const response = await postApi.getPostById(postId);
      return response;
    } catch (error) {
      return error;
    }
  },
);

export const likePost = createAsyncThunk("post/likePost", async (postId) => {
  try {
    const response = await postApi.likePost(postId);
    return response;
  } catch (error) {
    return error;
  }
});

export const unlikePost = createAsyncThunk(
  "post/unlikePost",
  async (postId) => {
    try {
      const response = await postApi.unlikePost(postId);
      return response;
    } catch (error) {
      return error;
    }
  },
);

export const ratePost = createAsyncThunk(
  "post/ratePost",
  async ({ data, id }) => {
    try {
      const response = await postApi.ratePost(data, id);
      return response;
    } catch (error) {
      return error;
    }
  },
);

export const pollVote = createAsyncThunk(
  "post/pollVote",
  async ({ data, id }) => {
    try {
      const response = await postApi.pollVote(data, id);
      return response;
    } catch (error) {
      return error;
    }
  },
);

export const newPost = createAsyncThunk("post/newPost", async (formData) => {
  try {
    const response = await postApi.newPost(formData);
    return response;
  } catch (error) {
    return error;
  }
});

export const newReply = createAsyncThunk(
  "post/newReply",
  async ({ data, id }) => {
    try {
      const response = await postApi.newReply(data, id);
      return response;
    } catch (error) {
      return error;
    }
  },
);

export const newRepost = createAsyncThunk("post/newRepost", async (id) => {
  try {
    const response = await postApi.repost(id);
    return response;
  } catch (error) {
    return error;
  }
});

// export const editPost = createAsyncThunk(
//   "post/editPost",
//   async ({ data, id }) => {
//     try {
//       const response = await postApi.editPost(data, id);
//       return response;
//     } catch (error) {
//       return error;
//     }
//   }
// );

export const deletePost = createAsyncThunk("post/deletePost", async (id) => {
  try {
    const response = await postApi.deletePost(id);
    return response;
  } catch (error) {
    return error;
  }
});

// Admin-only actions for pinning and featuring posts
export const pinPost = createAsyncThunk("post/pinPost", async (postId) => {
  try {
    const response = await postApi.pinPost(postId);
    return response;
  } catch (error) {
    return error;
  }
});

export const unpinPost = createAsyncThunk("post/unpinPost", async (postId) => {
  try {
    const response = await postApi.unpinPost(postId);
    return response;
  } catch (error) {
    return error;
  }
});

export const featurePost = createAsyncThunk(
  "post/featurePost",
  async (postId) => {
    try {
      const response = await postApi.featurePost(postId);
      return response;
    } catch (error) {
      return error;
    }
  },
);

export const unfeaturePost = createAsyncThunk(
  "post/unfeaturePost",
  async (postId) => {
    try {
      const response = await postApi.unfeaturePost(postId);
      return response;
    } catch (error) {
      return error;
    }
  },
);

export const hidePost = createAsyncThunk("post/hidePost", async (postId) => {
  try {
    const response = await postApi.hidePost(postId);
    return response;
  } catch (error) {
    return error;
  }
});

export const unhidePost = createAsyncThunk(
  "post/unhidePost",
  async (postId) => {
    try {
      const response = await postApi.unhidePost(postId);
      return response;
    } catch (error) {
      return error;
    }
  },
);
